import React, { useEffect, useState } from 'react';
import { ArrowUpShort } from 'react-bootstrap-icons';
import useScrollPosition from '../../../hooks/use_scroll_position';
import BtnIcon from './btn_icon';

const ScrollToTopBtn = () => {
	const scrollPosition = useScrollPosition();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const footerElement = document.getElementById('footer');

		if (footerElement) {
			const footerTop = footerElement.getBoundingClientRect().top;

			const windowHeight = window.innerHeight;

			setIsVisible(footerTop <= windowHeight);
		}
	}, [scrollPosition]);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="">
			<BtnIcon
				className="position-fixed bottom-0 end-0 m-3 fade-in"
				linkType="button"
				onClick={scrollToTop}
			>
				<ArrowUpShort />
			</BtnIcon>
		</div>
	);
};

export default ScrollToTopBtn;
